<template>
    <div class="appointment-card">
        <div class="appointment-card-body">
            <div class="clear">
                <div class="left"><h3 class="fs2">{{item.title}}</h3></div>
                <div class="right">
                    <!-- 拒绝理由 -->
                    <van-icon name="question" v-if="item.status=='refused'" class="red" @click="tips(item.refusedReason)"/>
                </div>
                <div class="right fs2" v-bind:class="classobject" v-text="mystatus(item.status)">
                </div>
                
            </div>
        </div>
        <div class="appointment-card-footer clear">
            <div class="left fs2 c9">
                <!-- <i class="iconfont">&#xef25;</i> -->
                {{starttime}}~{{endtime}}
            </div>
            <div class="fs2 right">
                <van-button v-if="item.status=='passed'||item.status=='used'" type="primary" size="mini" @click="signIn(item.id,'signed')">签卡</van-button>
                <van-button v-if="item.status=='applying'||item.status=='passed'" type="warning" size="mini" plain style="width:auto;padding:0 0.05rem;" @click="signIn(item.id,'canceled')">取消预约</van-button>
                <van-button v-else-if="item.status=='signed'" class="c9" size="mini">已签卡</van-button>
            </div>
        </div>
    </div>
    <!-- appointment-card -->
</template>
<script>
import Vue from 'vue';
import moment from 'moment';
import { Toast } from 'vant';
moment.locale('zh-cn');
Vue.use(Toast);

export default {
    name: 'AppointmentCard',
    props:[
        "item"
    ],
    data(){
        return {
            starttime: moment(this.item.startTime*1000).format('YYYY-MM-DD HH:mm'),
            endtime:moment(this.item.endTime*1000).format('HH:mm'),
            classobject:'appointment-card-body__status--success'
        }
    },
    methods:{
        mystatus(status){
            if(status=='applying'){
                return '等待俱乐部确认'
            }else if(status=='passed' || status=='signed'){
                return '预约成功'
            }else if(status=='refused'){
                this.classobject="appointment-card-body__status--fail"
                return '预约失败'
            }else if(status=='canceled'){
                this.classobject="c9"
                return '已取消'
            }else if(status == 'used'){
                this.classobject="c9"
                return '已使用'
            }
        },
        signIn(id,status){
            //签卡
            this.$http.post('club_user_reserve/changeStatus',{
                id:id,
                status: status
            }).then(res=>{
                this.item.status = status
            })
        },
        tips(msg){
            Toast(msg);
        }
    }
}
</script>
<style lang="less" scoped>
@mg-default:.15rem;
.appointment-card{ 
    position: relative;
    height: 0.85rem;
    margin-top: .1rem;
    padding:.1rem; 
    font-size: .16rem; 
    background-color: #fff; 
    border-radius: .03rem; 
    box-shadow: rgba(0,0,0,.2) 0 0 .05rem; 
    color: #444;
    z-index: 1;
    &-body{
        position: absolute;
        top: @mg-default; left: @mg-default; right: @mg-default;
        z-index: 1;
        &__status{
            &--success{ 
                color: #68c864;
            }
            &--fail{ 
                color: #f00;
            }
        }
    }
    &-footer{
        position: absolute;
        bottom: @mg-default; left: @mg-default; right: @mg-default;
        
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ReservedCard.vue